
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import Index2025 from "./pages/Index2025";
import Schedule2025 from "./pages/Schedule2025";
import Index2026 from "./pages/Index2026";
import Schedule2026 from "./pages/Schedule2026";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <LanguageProvider>
          <Routes>
            {/* 2026 Edition (Current/Default) */}
            <Route path="/" element={<Index2026 />} />
            <Route path="/schedule" element={<Schedule2026 />} />
            
            {/* 2025 Edition (Archive) */}
            <Route path="/2025" element={<Index2025 />} />
            <Route path="/2025/schedule" element={<Schedule2025 />} />
            
            {/* Redirects for backward compatibility */}
            <Route path="/2026" element={<Navigate to="/" replace />} />
            <Route path="/2026/schedule" element={<Navigate to="/schedule" replace />} />
          </Routes>
        </LanguageProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
